<template>
    <ul class="ut--mx-4 sm:ut--mx-0">
        <slot></slot>
    </ul>
</template>

<script>
export default {
  name: 'Accordian',
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  ul {
    @apply ut-relative;
  }
</style>
